import React from 'react';
import { Nav, ListGroup, Collapse, Form } from 'react-bootstrap';

// Sidebar solo usa SearchBar y renderMenu, el resto se mantiene limpio.
const Sidebar = ({ menu, onMenuClick, open, handleToggle, onSearchFocus }) => {
  const [selected, setSelected] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [isSearchActive, setIsSearchActive] = React.useState(false);

  const handleItemClick = (item) => {
    setSelected(item.cod);
    if (item.sub && item.sub.length > 0) {
      handleToggle(item.cod, item.sub);
    } else {
      onMenuClick(item.url);
    }
  };

  const filterMenu = (items, query) => {
    if (!query) return items;
    return items
      .map(item => {
        if (item.sub && item.sub.length > 0) {
          const filteredSub = filterMenu(item.sub, query);
          if (
            item.nom.toLowerCase().includes(query) ||
            filteredSub.length > 0
          ) {
            return { ...item, sub: filteredSub };
          }
          return null;
        }
        return item.nom.toLowerCase().includes(query) ? item : null;
      })
      .filter(Boolean);
  };

  const renderMenu = (items, paddingLeft = 20) => {
    if (!Array.isArray(items)) return null;
    return items.map(item => (
      <React.Fragment key={item.cod}>
        <ListGroup.Item
          className={selected === item.cod ? 'bg-primary text-white' : 'bg-transparent'}
          style={{ paddingLeft, paddingRight: '1px', cursor: 'pointer' }}
          onClick={() => handleItemClick(item)}
          aria-controls={item.cod}
          cod={item.cod}
        >
          <i className={item.ico}></i> {item.nom}
        </ListGroup.Item>
        {item.sub && item.sub.length > 0 && (
          <Collapse in={open[item.cod] || isSearchActive} id={item.cod}>
            <Nav className="flex-column list-group">
              <ListGroup className="rounded-0">
                {renderMenu(item.sub, paddingLeft + 20)}
              </ListGroup>
            </Nav>
          </Collapse>
        )}
      </React.Fragment>
    ));
  };

  const filteredMenu = filterMenu(menu, search.trim().toLowerCase());

  return (
    <>
      <ListGroup.Item className='bg-transparent border-0 p-2'>
        <Form className="d-flex b-0" onSubmit={e => e.preventDefault()}>
          <Form.Control
            name="search"
            type="search"
            placeholder="Buscar"
            aria-label="Buscar"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setIsSearchActive(e.target.value.trim() !== ''); }}
            onFocus={(e) => { onSearchFocus(true); if (search.trim() !== '') setIsSearchActive(true); e.stopPropagation(); }}
            onBlur={(e) => { onSearchFocus(false); setIsSearchActive(false); e.stopPropagation(); }}
            onClick={(e) => e.stopPropagation()}
            autoComplete="off"
          />
        </Form>
      </ListGroup.Item>
      <Nav className="flex-column list-group">
        <ListGroup className="rounded-0">
          {renderMenu(filteredMenu)}
        </ListGroup>
      </Nav>
    </>
  );
};

export default Sidebar;
